import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/PrivacyPage.head';
import { PrivacyPage } from '@pages/PrivacyPage';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
  head: () => head,
});
